"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredParamsClaim = exports.ClaimReason = exports.ProofName = exports.ClaimStatus = void 0;
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["PENDING"] = "PENDING";
    ClaimStatus["APPROVED"] = "APPROVED";
    ClaimStatus["REJECTED"] = "REJECTED";
    ClaimStatus["RETRACTED"] = "RETRACTED";
    ClaimStatus["APPEALED"] = "APPEALED";
})(ClaimStatus = exports.ClaimStatus || (exports.ClaimStatus = {}));
var ProofName;
(function (ProofName) {
    ProofName["PROOF_OF_CUSTOMER_COMMUNICATION"] = "Proof of Customer Communication";
})(ProofName = exports.ProofName || (exports.ProofName = {}));
var ClaimReason;
(function (ClaimReason) {
    ClaimReason["DELIVERED_BUT_LOST"] = "DELIVERED_BUT_LOST";
    ClaimReason["NO_TRACKING_MOVEMENT"] = "NO_TRACKING_MOVEMENT";
    ClaimReason["DELIVERED_DAMAGED"] = "DELIVERED_DAMAGED";
    ClaimReason["INCORRECT_PRODUCT"] = "INCORRECT_PRODUCT";
    ClaimReason["MISSING_PRODUCT"] = "MISSING_PRODUCT";
})(ClaimReason = exports.ClaimReason || (exports.ClaimReason = {}));
exports.requiredParamsClaim = [
    { name: "sellerId", type: "string" },
    { name: "claimReason", type: "string" },
    { name: "claimAmount", type: "number" },
    { name: "claimSource", type: "string" },
    { name: "claimCreator", type: "string" },
    { name: "deduplicationRef", type: "string" },
    { name: "originalCost", type: "number" },
    { name: "claimAmount", type: "number" },
];
//# sourceMappingURL=Claim.js.map